import { render, staticRenderFns } from "./AdminTariffeView.vue?vue&type=template&id=5c50c3c7&"
import script from "./AdminTariffeView.vue?vue&type=script&lang=ts&"
export * from "./AdminTariffeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports